var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"result",attrs:{"to":_vm.result.to}},[_c('img',{staticClass:"avatar supel",attrs:{"src":_vm.result.avatar}}),_c('div',{staticClass:"text"},[_c('div',{staticClass:"name"},[_vm._v(" "+_vm._s(_vm.result.name)+" ")]),_c('div',{staticClass:"tag"},[_vm._v(" "+_vm._s(_vm.result.tag)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }